exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".profile-picture {\n  height: 100px;\n  width: 100px; }\n\n.profile-picture-container {\n  margin: 20px auto; }\n\n.last-activity {\n  color: #565656;\n  font-size: 12.5px;\n  margin-top: 4px;\n  letter-spacing: -0.02em; }\n  .last-activity .clock {\n    font-size: 17px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/colaboradores/colaborador-detail/colaborador-detail.component.scss
// module id = ../../../../../src/app/components/colaboradores/colaborador-detail/colaborador-detail.component.scss
// module chunks = 0